import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = {
  key: 0,
  class: "rate fixedRate"
}
const _hoisted_5 = {
  key: 1,
  class: "rate variableRate"
}

import { computed, ref, watch } from "vue";
import { useStore } from "vuex";
import { RateTypeNames } from "@/config/constants";
import { RefiRatePlanViewModel } from "@/models/refi";
import RefiProgramLoanOptionDetails from "@/components/refi-loan-configuration/RefiProgramLoanOptionDetails.vue";

interface Props {
  ratePlanOption: RefiRatePlanViewModel;
  header?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'RefiProgramLoanOption',
  props: {
    ratePlanOption: {},
    header: { default: "" }
  },
  setup(__props: any) {

const props = __props;

const store = useStore();

const selectedRatePlan = ref<any | undefined>(undefined);
const singleRateOptionClicked = ref<boolean>(false);

const fixedPaymentCalculationErrorText = computed(
  () => props.ratePlanOption?.estimatedPaymentFixedStatus,
);

const variablePaymentCalculationErrorText = computed(
  () => props.ratePlanOption?.estimatedPaymentVariableStatus,
);

const paymentCalculationError = computed(
  () =>
    (fixedPaymentCalculationErrorText.value &&
      fixedPaymentCalculationErrorText.value?.length > 0) ||
    (variablePaymentCalculationErrorText.value &&
      variablePaymentCalculationErrorText.value?.length > 0),
);

const paymentCalculationErrorText = computed(() =>
  paymentCalculationError.value ? "(Currently Unavailable)" : "",
);

const fixedRateOption = computed(() => props.ratePlanOption["fixedRate"]);

const variableRateOption = computed(() => props.ratePlanOption["variableRate"]);

const selectedRatePlanId = computed(
  () => store.state.refiLoanConfigurationModule.selectedRatePlanId,
);
const singleRateTypeAvailable = computed(
  () =>
    (props.ratePlanOption?.hasFixedRate && !props.ratePlanOption?.hasVariableRate) ||
    (!props.ratePlanOption?.hasFixedRate && props.ratePlanOption?.hasVariableRate),
);

const promoText = computed(() => {
  return props.ratePlanOption.greaterThan10YearPromoDisclaimerText
    ? props.ratePlanOption.greaterThan10YearPromoDisclaimerText?.toUpperCase()
    : "";
});

function clicked() {
  if (singleRateTypeAvailable.value) {
    singleRateOptionClicked.value = true;
  }
}
async function updatePaymentOption(payment: any, rateType?: string) {
  selectedRatePlan.value = props.ratePlanOption;

  await store.dispatch(
    "refiLoanConfigurationModule/setSelectedRateTerm",
    props.ratePlanOption.year,
  );
  await store.dispatch("refiLoanConfigurationModule/setSelectedRateOption", payment);
  await store.dispatch("refiLoanConfigurationModule/setSelectedRatePlanId", payment?.rateId);
  await store.dispatch("refiLoanConfigurationModule/setSelectedRateType", rateType);

  singleRateOptionClicked.value = false;
}

watch(
  () => selectedRatePlanId.value,
  (currentValue: boolean) => {
    if (currentValue) {
      singleRateOptionClicked.value = false;
    }
  },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["option program-tile-btn", { single: singleRateTypeAvailable.value }]),
    onClick: clicked
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("p", null, _toDisplayString(__props.ratePlanOption.year) + " Year Rates & Estimated Payments " + _toDisplayString(paymentCalculationErrorText.value), 1),
      (promoText.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(promoText.value), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      (__props.ratePlanOption.hasFixedRate)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(RefiProgramLoanOptionDetails, {
              rateType: _unref(RateTypeNames).FIXED,
              "rate-term": __props.ratePlanOption.year,
              option: fixedRateOption.value,
              singleRateTypeAvailable: singleRateTypeAvailable.value,
              singleRateOptionClicked: singleRateOptionClicked.value,
              onRadioButtonClicked: _cache[0] || (_cache[0] = ($event: any) => (updatePaymentOption(fixedRateOption.value, _unref(RateTypeNames).FIXED)))
            }, null, 8, ["rateType", "rate-term", "option", "singleRateTypeAvailable", "singleRateOptionClicked"])
          ]))
        : _createCommentVNode("", true),
      (__props.ratePlanOption.hasVariableRate)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(RefiProgramLoanOptionDetails, {
              rateType: _unref(RateTypeNames).VARIABLE,
              "rate-term": __props.ratePlanOption.year,
              option: variableRateOption.value,
              singleRateTypeAvailable: singleRateTypeAvailable.value,
              onRadioButtonClicked: _cache[1] || (_cache[1] = ($event: any) => (updatePaymentOption(variableRateOption.value, _unref(RateTypeNames).VARIABLE))),
              singleRateOptionClicked: singleRateOptionClicked.value
            }, null, 8, ["rateType", "rate-term", "option", "singleRateTypeAvailable", "singleRateOptionClicked"])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})